<template>
    <div>
        <form class="needs-validation" autocomplete="off">
            <div class="card">
                <div class="card-header">
                    <h3 class="mb-0 title--click title--screen">基本設定</h3>
                </div>
                <div class="card-body">
                    <div class="form-group row">
                        <label class="col-sm-3 text-nowrap" style="min-width: 150px">ページタイトル</label>
                        <div class="col-sm-9">
                            <InputText
                                :model.sync="templateForm.title"
                                :config="configs.configFieldTitle"
                                @blur="handleValidateField(configs.configFieldTitle)"
                            />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 text-nowrap" style="min-width: 150px">HEADテキスト</label>
                        <div class="col-sm-9">
                            <HTMLCodeEditor ref="editor" v-model="templateForm.head_text" />
                            <p class="text-note mt-1" style="color: #74788d">
                                ※こちらに書かれた情報のうちHEADテキスト収まる適切なタグのみ自動で反映されます。
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    <h3 class="mb-0 title--click title--screen">文字設定</h3>
                </div>
                <div class="card-body">
                    <div class="form-group row border-bottom pb-2 align-items-center">
                        <label class="col-sm-3 text-nowrap" style="min-width: 150px">
                            <div class="mb-2">質問・回答で使用する文字</div>
                            <div
                                class="border p-2 text-center"
                                style="white-space: break-spaces"
                                :style="{
                                    fontSize: templateForm.character_settings.qa_typography.font_size
                                        ? templateForm.character_settings.qa_typography.font_size +
                                          (templateForm.character_settings.qa_typography.unit.value || 'px')
                                        : '',
                                    color: templateForm.character_settings.qa_typography.color,
                                    fontFamily: templateForm.character_settings.qa_typography.font.value
                                }"
                            >
                                サンプル/Sample
                            </div>
                        </label>
                        <div class="col-sm-9">
                            <div class="row align-items-center">
                                <label class="col-sm-1 text-nowrap" style="min-width: 80px">フォント</label>
                                <div class="col-sm-3">
                                    <Multiselect
                                        :id="`select-qa_font`"
                                        :value.sync="templateForm.character_settings.qa_typography.font"
                                        :options="options.fontFamily"
                                        :config="configs.configFieldSelectFont"
                                    />
                                </div>
                                <div class="col-sm-1 px-0">
                                    <InputText
                                        :model.sync="templateForm.character_settings.qa_typography.font_size"
                                        :config="configs.configFieldFontSize"
                                        @blur="handleValidateField(configs.configFieldFontSize)"
                                    />
                                </div>
                                <div class="col-sm-3">
                                    <Multiselect
                                        :id="`select-qa_font_styles`"
                                        :value.sync="templateForm.character_settings.qa_typography.unit"
                                        :options="options.unitsNotIncludePercent"
                                        :config="configs.configFieldSelectUnits"
                                    />
                                </div>
                                <label class="col-sm-1 text-right">色</label>
                                <div class="d-flex col-sm-2" style="gap: 1rem">
                                    <InputText
                                        style="min-width: 100px"
                                        :model.sync="templateForm.character_settings.qa_typography.color"
                                        :config="{
                                            type: 'color',
                                            classCustom: 'form-control-color',
                                            error: false
                                        }"
                                    />
                                    <InputText
                                        style="min-width: 100px"
                                        :model.sync="templateForm.character_settings.qa_typography.color"
                                        :config="configs.configFieldColor"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row border-bottom pb-2">
                        <label class="col-sm-3 text-nowrap" style="min-width: 150px">
                            <div class="mb-2">エラーメッセージの文字</div>
                        </label>
                        <div class="col-sm-9">
                            <div class="row align-items-center border-bottom pb-3 mb-3">
                                <label class="col-sm-1 text-nowrap" style="min-width: 80px">フォント</label>
                                <div class="col-sm-3">
                                    <Multiselect
                                        :id="`select-qa_font2`"
                                        :value.sync="templateForm.character_settings.error_typography.font"
                                        :options="options.fontFamily"
                                        :config="configs.configFieldSelectFont"
                                    />
                                </div>
                                <div class="col-sm-1 px-0">
                                    <InputText
                                        :model.sync="templateForm.character_settings.error_typography.font_size"
                                        :config="configs.configFieldFontSizeError"
                                        @blur="handleValidateField(configs.configFieldFontSizeError)"
                                    />
                                </div>
                                <div class="col-sm-3">
                                    <Multiselect
                                        :id="`select-qa_font_styles2`"
                                        :value.sync="templateForm.character_settings.error_typography.unit"
                                        :options="options.unitsNotIncludePercent"
                                        :config="configs.configFieldSelectUnits"
                                    />
                                </div>
                                <label class="col-sm-1 text-right">色</label>
                                <div class="d-flex col-sm-2" style="gap: 1rem">
                                    <InputText
                                        style="min-width: 100px"
                                        :model.sync="templateForm.character_settings.error_typography.color"
                                        :config="{
                                            type: 'color',
                                            classCustom: 'form-control-color',
                                            error: false
                                        }"
                                    />
                                    <InputText
                                        style="min-width: 100px"
                                        :model.sync="templateForm.character_settings.error_typography.color"
                                        :config="configs.configFieldColor"
                                    />
                                </div>
                            </div>
                            <!-- <div class="row align-items-center pb-2">
                                <label class="col-sm-1 text-nowrap" style="min-width: 100px">行頭スタイル</label>
                                <div class="col-sm-2">
                                    <Multiselect
                                        :id="`select-headingStyles`"
                                        :value.sync="templateForm.character_settings.heading_style"
                                        :options="options.headingStyles"
                                        :config="configs.configSelectHeadingStyles"
                                    />
                                </div>
                            </div> -->
                        </div>
                    </div>
                    <div class="form-group row border-bottom pb-3 align-items-center">
                        <label class="col-sm-3 text-nowrap" style="min-width: 150px">
                            <div class="mb-2">入力例(プレースホルダ)</div>
                        </label>
                        <div class="col-sm-9">
                            <div class="row align-items-center">
                                <label class="px-2">色</label>
                                <div class="d-flex col-sm-2" style="gap: 1rem">
                                    <InputText
                                        style="min-width: 100px"
                                        :model.sync="templateForm.character_settings.color_input_placeholder"
                                        :config="{
                                            type: 'color',
                                            classCustom: 'form-control-color',
                                            error: false
                                        }"
                                    />
                                    <InputText
                                        style="min-width: 100px"
                                        :model.sync="templateForm.character_settings.color_input_placeholder"
                                        :config="configs.configFieldColor"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    <h3 class="mb-0 title--click title--screen">背景設定</h3>
                </div>
                <div class="card-body">
                    <div class="form-group row border-bottom pb-3 align-items-center">
                        <label class="col-sm-3 text-nowrap" style="min-width: 150px">
                            <div class="mb-2">背景色</div>
                        </label>
                        <div class="col-sm-9">
                            <div class="row align-items-center">
                                <label class="px-2">色</label>
                                <div class="d-flex col-sm-2" style="gap: 1rem">
                                    <InputText
                                        style="min-width: 100px"
                                        :model.sync="templateForm.background_settings.background_color"
                                        :config="{
                                            type: 'color',
                                            classCustom: 'form-control-color',
                                            error: false
                                        }"
                                    />
                                    <InputText
                                        style="min-width: 100px"
                                        :model.sync="templateForm.background_settings.background_color"
                                        :config="configs.configFieldColor"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 text-nowrap" style="min-width: 150px">
                            <div class="mb-2">背景画像</div>
                            <div
                                v-if="!(templateForm.background_image?.path && arrExtension.includes(templateForm.background_image.extension))"
                                class="text-muted border p-2 text-center"
                            >
                                未設定
                            </div>
                            <div v-else style="width: 200px; height: 200px" class="position-relative">
                                <b-img
                                    class=""
                                    thumbnail
                                    fluid
                                    :src="templateForm.background_image?.path"
                                    :alt="templateForm.background_image.origin_name"
                                    style="width: 100%; height: 100%; object-fit: cover; object-position: center; border-radius: 10px"
                                ></b-img>
                                <span
                                    style="cursor: pointer; position: absolute; top: -8px; right: -14px; font-size: 18px; font-weight: 700"
                                    @click="templateForm.background_image = null"
                                    ><i class="ri-close-line" style="vertical-align: bottom"></i
                                ></span>
                            </div>
                        </label>
                        <div class="col-sm-9">
                            <div class="row align-items-center mb-4">
                                <div class="col">
                                    <UploadImageCommon
                                        :fileValues.sync="templateForm.background_image"
                                        :id="`TitlePrizeImgLP`"
                                        :config="{
                                            maxSize: 1024,
                                            allowedExtension: [
                                                'image/jpeg',
                                                'image/jpg',
                                                'image/png',
                                                'image/gif',
                                                'image/bmp',
                                                'image/webp',
                                                'image/svg',
                                                'image/svg+xml'
                                            ],
                                            isPreview: false
                                        }"
                                    >
                                        <template #warning>
                                            <div style="font-size: 13px">
                                                {{ $t('managerForm.settingDesign.noteImageBeautiful') }}
                                            </div>
                                        </template>
                                    </UploadImageCommon>
                                </div>
                            </div>
                            <div class="row align-items-center mb-4">
                                <div class="px-2">
                                    <InputCheckBox
                                        :model.sync="templateForm.background_settings.is_full_width_bg_image"
                                        :id="`check-background_image_full_width`"
                                        label="横幅100％表示"
                                        :value="templateForm.background_settings.is_full_width_bg_image"
                                    />
                                </div>
                            </div>
                            <div class="row align-items-center mb-4">
                                <label class="col-sm-2 mb-0">繰り返し</label>
                                <div v-if="!templateForm.background_settings.is_full_width_bg_image" class="px-2">
                                    <InputCheckBox
                                        :model.sync="templateForm.background_settings.repeat"
                                        :id="`check-background_settings_repeat`"
                                        value="horizontal"
                                        label="水平方向"
                                    />
                                </div>
                                <div class="px-2">
                                    <InputCheckBox
                                        :model.sync="templateForm.background_settings.repeat"
                                        :id="`check-background_settings_repeat2`"
                                        value="vertical"
                                        label="垂直方向"
                                    />
                                </div>
                            </div>
                            <div v-if="!templateForm.background_settings.is_full_width_bg_image" class="row align-items-center">
                                <label class="col-sm-2 mb-0">開始位置</label>
                                <label class="col-sm-1 text-nowrap">水平方向</label>
                                <div class="col-sm-2">
                                    <Multiselect
                                        :id="`select-horizontal_direction`"
                                        :value.sync="templateForm.background_settings.horizontal_direction"
                                        :options="options.directions"
                                        :config="configs.configFieldSelectDirection"
                                    />
                                </div>
                                <label class="col-sm-1 text-nowrap">垂直方向</label>
                                <div class="col-sm-2">
                                    <Multiselect
                                        :id="`select-qa_font`"
                                        :value.sync="templateForm.background_settings.vertical_direction"
                                        :options="options.directionsvertical"
                                        :config="configs.configFieldSelectDirection"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    <h3 class="mb-0 title--click title--screen">テーブルレイアウト設定</h3>
                </div>
                <div class="card-body">
                    <div class="form-group row border-bottom pb-3">
                        <label class="col-sm-3 text-nowrap" style="min-width: 150px">
                            <div class="mb-2">横幅</div>
                        </label>
                        <div class="col-sm-9">
                            <div class="row align-items-center">
                                <label class="col-sm-1 text-nowrap">単位指定</label>
                                <div class="col-sm-3 mr-2">
                                    <Multiselect
                                        :id="`select-qa_font`"
                                        :value.sync="templateForm.table_settings.width.unit"
                                        :options="options.unitsIncludeAuto"
                                        :config="configs.configFieldSelectUnits"
                                    />
                                </div>
                                <table id="tablesample" class="table table-bordered col-sm-6">
                                    <tbody>
                                        <tr>
                                            <td rowspan="1" colspan="2" class="tableWidth text-center">
                                                <div class="row align-items-center justify-content-center">
                                                    <label class="px-2 mb-0">テーブル幅</label>
                                                    <div class="px-2">
                                                        <InputText
                                                            style="width: 100px"
                                                            :model.sync="templateForm.table_settings.width.table_width"
                                                            :config="configs.configFieldTableWidth"
                                                            @blur="handleValidateField(configs.configFieldTableWidth, 'table_width')"
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="1" rowspan="1" id="thsample" class="cleartable text-center">
                                                <div class="row align-items-center justify-content-center">
                                                    <label class="px-2 mb-0">質問欄</label>
                                                    <div class="px-2">
                                                        <InputText
                                                            style="width: 100px"
                                                            :model.sync="templateForm.table_settings.width.question_width"
                                                            :config="configs.configFieldQuestionWidth"
                                                            @blur="handleValidateField(configs.configFieldQuestionWidth, 'table_width')"
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td colspan="1" rowspan="1" id="tdsample" class="cleartable text-center">
                                                <div class="row align-items-center justify-content-center">
                                                    <label class="px-2 mb-0">回答欄</label>
                                                    <div class="px-2">
                                                        <InputText
                                                            style="width: 100px"
                                                            :model.sync="templateForm.table_settings.width.answer_width"
                                                            :config="configs.configFieldAnswerWidth"
                                                            @blur="handleValidateField(configs.configFieldAnswerWidth, 'table_width')"
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row border-bottom pb-3">
                        <label class="col-sm-3 text-nowrap" style="min-width: 150px">
                            <div class="mb-2">ブラウザ内表示位置</div>
                        </label>
                        <div class="col-sm-9">
                            <div class="row align-items-center mb-4">
                                <label class="px-2 mb-0">上</label>
                                <div class="col-sm-1 px-0">
                                    <InputText
                                        :model.sync="templateForm.table_settings.display_position_in_browser.top.value"
                                        :config="configs.configFieldTableTopWidth"
                                        @blur="handleValidateField(configs.configFieldTableTopWidth)"
                                    />
                                </div>
                                <div class="col-sm-3">
                                    <Multiselect
                                        :value.sync="templateForm.table_settings.display_position_in_browser.top.unit"
                                        :options="options.unitsNotIncludePercent"
                                        :config="configs.configFieldSelectUnits"
                                    />
                                </div>
                                <label class="col-sm-1 text-right mb-0">下</label>
                                <div class="col-sm-1 px-0">
                                    <InputText
                                        :model.sync="templateForm.table_settings.display_position_in_browser.bottom.value"
                                        :config="configs.configFieldTableBottomWidth"
                                        @blur="handleValidateField(configs.configFieldTableBottomWidth)"
                                    />
                                </div>
                                <div class="col-sm-3">
                                    <Multiselect
                                        :value.sync="templateForm.table_settings.display_position_in_browser.bottom.unit"
                                        :options="options.unitsNotIncludePercent"
                                        :config="configs.configFieldSelectUnits"
                                    />
                                </div>
                            </div>
                            <div class="row align-items-center pb-4 border-bottom mb-4">
                                <label class="px-2 mb-0">左</label>
                                <div class="col-sm-1 px-0">
                                    <InputText
                                        :model.sync="templateForm.table_settings.display_position_in_browser.left.value"
                                        :config="configs.configFieldTableLeftWidth"
                                        @blur="handleValidateField(configs.configFieldTableLeftWidth)"
                                    />
                                </div>
                                <div class="col-sm-3">
                                    <Multiselect
                                        :id="`select-qa_font_size`"
                                        :value.sync="templateForm.table_settings.display_position_in_browser.left.unit"
                                        :options="options.unitsIncludeAutoNotPercent"
                                        :config="configs.configFieldSelectUnits"
                                        @select="changeUnitAlignTable"
                                    />
                                </div>
                                <label class="col-sm-1 text-right mb-0">右</label>
                                <div class="col-sm-1 px-0">
                                    <InputText
                                        :model.sync="templateForm.table_settings.display_position_in_browser.right.value"
                                        :config="configs.configFieldTableRightWidth"
                                        @blur="handleValidateField(configs.configFieldTableRightWidth)"
                                    />
                                </div>
                                <div class="col-sm-3">
                                    <Multiselect
                                        :id="`select-qa_font_size`"
                                        :value.sync="templateForm.table_settings.display_position_in_browser.right.unit"
                                        :options="options.unitsIncludeAutoNotPercent"
                                        :config="configs.configFieldSelectUnits"
                                        @select="changeUnitAlignTable"
                                    />
                                </div>
                            </div>
                            <div class="row align-items-center">
                                <label class="col-sm-2 mb-0">簡易設定</label>
                                <div v-for="layoutAlignment in options.layoutAlignments" :key="layoutAlignment.value" class="px-2">
                                    <InputRadio
                                        :model.sync="templateForm.table_settings.layout_alignment_setting"
                                        :id="`check-layout-${layoutAlignment.value}`"
                                        :value="layoutAlignment.value"
                                        :label="layoutAlignment.label"
                                        @change="changeLayoutAlignment"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="form-group row border-bottom pb-3">
                        <label class="col-sm-3 text-nowrap" style="min-width: 150px">
                            <div class="mb-2">ブロック表示位置</div>
                        </label>
                        <div class="col-sm-9">
                            <div class="row align-items-center mb-2">
                                <div v-for="blockAlignment in options.blockAlignments" :key="blockAlignment.value" class="px-2">
                                    <InputRadio
                                        :model.sync="templateForm.table_settings.block_display_alignment"
                                        :id="`check-block-${blockAlignment.value}`"
                                        :value="blockAlignment.value"
                                        :label="blockAlignment.label"
                                    />
                                </div>
                            </div>
                            <div style="font-size: 13px">※テーブル幅がヘッダ・フッタの幅より狭い場合に有効な設定です。</div>
                        </div>
                    </div> -->
                    <div class="form-group row border-bottom pb-3">
                        <label class="col-sm-3 text-nowrap" style="min-width: 150px">
                            <div class="mb-2">設問レイアウト</div>
                        </label>
                        <div class="col-sm-9">
                            <div class="row align-items-center">
                                <div class="px-2">
                                    <InputRadio
                                        :model.sync="templateForm.table_settings.question_layout"
                                        :id="`radio-questionLayout-1`"
                                        value="horizontal"
                                        label="横並び"
                                    />
                                </div>
                                <div class="px-2">
                                    <InputRadio
                                        :model.sync="templateForm.table_settings.question_layout"
                                        :id="`radio-questionLayout-2`"
                                        value="vertical"
                                        label="縦並び"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row border-bottom pb-3">
                        <label class="col-sm-3 text-nowrap" style="min-width: 150px">
                            <div class="mb-2">枠線</div>
                        </label>
                        <div class="col-sm-9">
                            <div class="row align-items-center mb-3">
                                <label class="col-sm-2 mb-0">線種</label>
                                <div class="col-sm-3">
                                    <Multiselect
                                        :value.sync="templateForm.table_settings.border_setting.type"
                                        :options="options.borderTypes"
                                        :config="configs.configFieldSelectBorderType"
                                    />
                                </div>
                            </div>
                            <div class="row align-items-center mb-3">
                                <label class="col-sm-2 mb-0">色</label>
                                <div class="d-flex col-sm-2" style="gap: 1rem">
                                    <InputText
                                        style="min-width: 100px"
                                        :model.sync="templateForm.table_settings.border_setting.color"
                                        :config="{
                                            type: 'color',
                                            classCustom: 'form-control-color',
                                            error: false
                                        }"
                                    />
                                    <InputText
                                        style="min-width: 100px"
                                        :model.sync="templateForm.table_settings.border_setting.color"
                                        :config="configs.configFieldColor"
                                    />
                                </div>
                            </div>
                            <div class="row align-items-center mb-4">
                                <label class="px-2 mb-0">太さ</label>
                                <div class="col-sm-1 px-0">
                                    <InputText
                                        :model.sync="templateForm.table_settings.line_thickness.value"
                                        :config="configs.configFieldLineThickness"
                                        @blur="handleValidateField(configs.configFieldLineThickness)"
                                    />
                                </div>
                                <div class="col-sm-3">
                                    <Multiselect
                                        :id="`select-qa_font_size`"
                                        :value.sync="templateForm.table_settings.line_thickness.unit"
                                        :options="options.unitsNotIncludePercent"
                                        :config="configs.configFieldSelectUnits"
                                    />
                                </div>
                            </div>
                            <div class="row align-items-center">
                                <label class="col-sm-2 mb-0">線の表示</label>
                                <div class="px-2">
                                    <InputRadio
                                        :model.sync="templateForm.table_settings.line_display"
                                        :id="`radio-displayLine-1`"
                                        value="collapse"
                                        label="重ねて表示(collapse)"
                                    />
                                </div>
                                <div class="px-2">
                                    <InputRadio
                                        :model.sync="templateForm.table_settings.line_display"
                                        :id="`radio-displayLine-2`"
                                        value="separate"
                                        label="個別に分けて表示(separate)"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row border-bottom pb-3">
                        <label class="col-sm-3 text-nowrap" style="min-width: 150px">
                            <div class="mb-2">セル</div>
                        </label>
                        <div class="col-sm-9">
                            <div class="row align-items-center mb-4">
                                <label class="px-2 mb-0">間隔</label>
                                <div class="col-sm-1 px-0">
                                    <InputText
                                        :model.sync="templateForm.table_settings.cell_setting.spacing.value"
                                        :config="configs.configFieldCellSpacing"
                                        @blur="handleValidateField(configs.configFieldCellSpacing)"
                                    />
                                </div>
                                <div class="col-sm-3">
                                    <Multiselect
                                        :value.sync="templateForm.table_settings.cell_setting.spacing.unit"
                                        :options="options.unitsNotIncludePercent"
                                        :config="configs.configFieldSelectUnits"
                                    />
                                </div>
                            </div>
                            <div class="row align-items-center mb-4">
                                <label class="px-2 mb-0">余白</label>
                                <div class="col-sm-1 px-0">
                                    <InputText
                                        :model.sync="templateForm.table_settings.cell_setting.margin.value"
                                        :config="configs.configFieldCellMargin"
                                        @blur="handleValidateField(configs.configFieldCellMargin)"
                                    />
                                </div>
                                <div class="col-sm-3">
                                    <Multiselect
                                        :value.sync="templateForm.table_settings.cell_setting.margin.unit"
                                        :options="options.unitsNotIncludePercent"
                                        :config="configs.configFieldSelectUnits"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row border-bottom pb-3">
                        <label class="col-sm-3 text-nowrap" style="min-width: 150px">
                            <div class="mb-2">セル背景色</div>
                        </label>
                        <div class="col-sm-9">
                            <div class="row align-items-center mb-3">
                                <label class="col-sm-2 mb-0">質問欄の背景色 </label>
                                <div class="d-flex col-sm-2" style="gap: 1rem">
                                    <InputText
                                        style="min-width: 100px"
                                        :model.sync="templateForm.table_settings.cell_background_color.question_background_color"
                                        :config="{
                                            type: 'color',
                                            classCustom: 'form-control-color',
                                            error: false
                                        }"
                                    />
                                    <InputText
                                        style="min-width: 100px"
                                        :model.sync="templateForm.table_settings.cell_background_color.question_background_color"
                                        :config="configs.configFieldColor"
                                    />
                                </div>
                            </div>
                            <div class="row align-items-center mb-3">
                                <label class="col-sm-2 mb-0">回答欄の背景色</label>
                                <div class="d-flex col-sm-2" style="gap: 1rem">
                                    <InputText
                                        style="min-width: 100px"
                                        :model.sync="templateForm.table_settings.cell_background_color.answer_background_color"
                                        :config="{
                                            type: 'color',
                                            classCustom: 'form-control-color',
                                            error: false
                                        }"
                                    />
                                    <InputText
                                        style="min-width: 100px"
                                        :model.sync="templateForm.table_settings.cell_background_color.answer_background_color"
                                        :config="configs.configFieldColor"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row border-bottom pb-3">
                        <label class="col-sm-3 text-nowrap" style="min-width: 150px">
                            <div class="mb-2">テキスト表示位置(質問欄)</div>
                        </label>
                        <div class="col-sm-9">
                            <div class="row align-items-center mb-3">
                                <div v-for="blockAlignment in options.blockAlignments" :key="blockAlignment.value" class="px-2">
                                    <InputRadio
                                        :model.sync="templateForm.table_settings.question_text_alignment.horizontal"
                                        :id="`check-question-horizontal-${blockAlignment.value}`"
                                        :value="blockAlignment.value"
                                        :label="blockAlignment.label"
                                    />
                                </div>
                            </div>
                            <!-- <div class="row align-items-center">
                                <div v-for="blockAlignment in options.blockAlignmentsVertical" :key="blockAlignment.value" class="px-2">
                                    <InputRadio
                                        :model.sync="templateForm.table_settings.question_text_alignment.vertical"
                                        :id="`check-question-vertical-${blockAlignment.value}`"
                                        :value="blockAlignment.value"
                                        :label="blockAlignment.label"
                                    />
                                </div>
                            </div> -->
                        </div>
                    </div>
                    <div class="form-group row border-bottom pb-3">
                        <label class="col-sm-3 text-nowrap" style="min-width: 150px">
                            <div class="mb-2">テキスト表示位置(回答欄)</div>
                        </label>
                        <div class="col-sm-9">
                            <div class="row align-items-center mb-3">
                                <div v-for="blockAlignment in options.blockAlignments" :key="blockAlignment.value" class="px-2">
                                    <InputRadio
                                        :model.sync="templateForm.table_settings.answer_text_alignment.horizontal"
                                        :id="`check-answer-horizontal-${blockAlignment.value}`"
                                        :value="blockAlignment.value"
                                        :label="blockAlignment.label"
                                    />
                                </div>
                            </div>
                            <!-- <div class="row align-items-center">
                                <div v-for="blockAlignment in options.blockAlignmentsVertical" :key="blockAlignment.value" class="px-2">
                                    <InputRadio
                                        :model.sync="templateForm.table_settings.answer_text_alignment.vertical"
                                        :id="`check-answer-vertical-${blockAlignment.value}`"
                                        :value="blockAlignment.value"
                                        :label="blockAlignment.label"
                                    />
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { InputText, InputCheckBox, InputRadio } from '@/components/Input';
import Multiselect from '@/components/Multiselect/main.vue';
import UploadImageCommon from '@/components/Uploads/Image/main.vue';
import { options, configs } from './constants';
import { validateTableWidth } from '../../handlers';
import { IMAGE_EXTENSIONS } from '@/utils/format';
import { validateField } from '@/utils/validate';
import HTMLCodeEditor from '@/components/HTMLCodeEditor/main.vue';

export default {
    name: 'TemplateDesign',
    components: {
        InputText,
        Multiselect,
        UploadImageCommon,
        InputCheckBox,
        InputRadio,
        HTMLCodeEditor
    },
    props: {
        templateForm: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            options: options,
            configs: configs,
            arrExtension: IMAGE_EXTENSIONS,
            htmlContent: '<p><strong>Hello</strong> Vue 2 + CodeMirror!</p>'
        };
    },
    methods: {
        refreshCodeMirror() {
            this.$refs.editor.refreshEditor();
        },

        handleValidateField(configField, action) {
            validateField(configField);
            if (action == 'table_width') {
                validateTableWidth(this.configs.configFieldTableWidth, this.configs.configFieldAnswerWidth, this.configs.configFieldQuestionWidth);
            }
        },
        changeUnitAlignTable() {
            if (
                this.templateForm.table_settings.display_position_in_browser.left.unit.value !== 'auto' &&
                this.templateForm.table_settings.display_position_in_browser.right.unit.value === 'auto'
            ) {
                this.templateForm.table_settings.layout_alignment_setting = 'align_left';
            } else if (
                this.templateForm.table_settings.display_position_in_browser.left.unit.value === 'auto' &&
                this.templateForm.table_settings.display_position_in_browser.right.unit.value !== 'auto'
            ) {
                this.templateForm.table_settings.layout_alignment_setting = 'align_right';
            } else if (
                this.templateForm.table_settings.display_position_in_browser.left.unit.value === 'auto' &&
                this.templateForm.table_settings.display_position_in_browser.right.unit.value === 'auto'
            ) {
                this.templateForm.table_settings.layout_alignment_setting = 'align_center';
            } else {
                this.templateForm.table_settings.layout_alignment_setting = '';
            }
        },
        changeLayoutAlignment() {
            if (this.templateForm.table_settings.layout_alignment_setting === 'align_left') {
                this.templateForm.table_settings.display_position_in_browser.left.unit = { label: 'px(ピクセル)', value: 'px' };
                this.templateForm.table_settings.display_position_in_browser.right.unit = { label: 'auto(自動調整)', value: 'auto' };
            } else if (this.templateForm.table_settings.layout_alignment_setting === 'align_right') {
                this.templateForm.table_settings.display_position_in_browser.right.unit = { label: 'px(ピクセル)', value: 'px' };
                this.templateForm.table_settings.display_position_in_browser.left.unit = { label: 'auto(自動調整)', value: 'auto' };
            } else if (this.templateForm.table_settings.layout_alignment_setting === 'align_center') {
                this.templateForm.table_settings.display_position_in_browser.left.unit = { label: 'auto(自動調整)', value: 'auto' };
                this.templateForm.table_settings.display_position_in_browser.right.unit = { label: 'auto(自動調整)', value: 'auto' };
            } else {
                this.templateForm.table_settings.display_position_in_browser.left.unit = { label: 'px(ピクセル)', value: 'px' };
                this.templateForm.table_settings.display_position_in_browser.right.unit = { label: 'px(ピクセル)', value: 'px' };
                this.templateForm.table_settings.width.unit = { label: '%(パーセント)', value: '%' };
                this.templateForm.table_settings.width.table_width = 100;
            }
        }
    },
    watch: {}
};
</script>

<style lang="scss" scoped></style>
